import axios from '@/axios.js'
// import Vue from 'vue'


export default {
  fetchVideoLibrary ({ commit }) {
    // console.log('inside action fetchVideoLibrary ')
    return new Promise((resolve, reject) => {
      axios
        .get('courses/video/all')
        .then((response) => {
          commit('SET_VIDEO_LIBRARY', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
